import React from 'react'

interface props {
  value: boolean,
  onChange?: any,
  className?: string
}

export default function CustomRadio({ value = false, onChange, className }: props) {
  return (
    <div className={`relative w-14 h-8 ${!value ? 'bg-[#F2DDE2] border-2 border-[#fff]' : 'bg-[#43AC12] border-2 border-[#fff]'} rounded-full cursor-pointer ${className}`} onClick={onChange}>
      <div className={`absolute top-[1px] left-0  ${className ? 'w-[20px] h-[20px]  pr-[0.01rem]' : 'w-6 h-6 m-0'}  rounded-full bg-primary-white  transition-transform duration-500 ${value && 'transform translate-x-full left-[0.2rem]'}`}>
      </div>
    </div>
  )
}
